import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

export const useClientAdmissions = (clientId, options = {}) =>
  useQuery({
    queryKey: ["client-admissions", clientId],
    queryFn: async () => {
      const res = await axios.get(`${API_URL}/student/client/${clientId}/admissions`);
      return res?.data?.data ?? [];
    },
    enabled: Boolean(clientId),
    refetchOnWindowFocus: false,
    ...options,
  });
